import React, { Fragment } from 'react';
import { AdaptableCard } from 'components/shared';
import {
    Title,
    Text,
    createStyles,
    Image,
} from '@mantine/core';
import { useSelector } from 'react-redux';

// const useStyles = createStyles(() => ({
//     title: {
//         color: 'rgba(51, 106, 63, 1)',
//         lineHeight: 1,
//     },
// }));

export default function WebsiteFooter(props) {
    const {
        // locale,
        location
    } = props;
    const GeneralTranslations = useSelector((state) => state.WebsiteLanguage.data.GeneralTranslations);
    const currentLanguage = useSelector((state) => state.WebsiteLanguage.data.language);

    const getCurrentYear = () => {
        return new Date().getFullYear();
    };

    const getManualLink = () => {
        const manualFiles = {
            sq: '/Manuali i perdorimit Agjencia për Parandalimin e Korrupsionit.pdf',
            en: '/Manual The Agency for Prevention of Corruption.pdf',
            sr: '/Manual Agencija za Sprečavanje Korupcije.pdf'
        };
        return manualFiles[currentLanguage] || manualFiles.sq;
    };

    return (
        <Fragment>
            <div className="footer-apk">
                {GeneralTranslations.copyright}
                {' '}
                ©
                {' '}
                {getCurrentYear()}
                {' '}
                {GeneralTranslations.apk}
                {' | '}
                <a className="manual-link" href={getManualLink()} target="_blank" rel="noopener noreferrer">
                {GeneralTranslations.ManualiPerdorimit}
                </a>
            </div>
        </Fragment>
    );
}
